/**
 * Удаляет из объекта свойства, значения которых — пустые строки.
 *
 * @param {Object} obj - Объект для очистки.
 * @returns {Object} Новый объект без пустых строк.
 */
export function removeEmptyStrings(obj) {
  return Object.fromEntries(
    Object.entries(obj).filter(([_, value]) => value !== '')
  );
}
